import React from 'react'
import { Route, Switch } from 'react-router'
import Home from '../components/Home'
import NoMatch from '../components/NoMatch'
import PrivateRoute from './PrivateRoute'
import FormDialogContainer from '../containers/FormDialogContainer'
import InboundProgram from '../containers/InboundProgramContainer'
import EagleRoute from './EagleRoute'

const routes = (
	<React.Fragment>
		<Switch>
			<PrivateRoute exact path="/" component={FormDialogContainer} />
			<PrivateRoute path="/home" component={Home} />
			<EagleRoute path="/inbound" component={InboundProgram} />
			<Route component={NoMatch} />
		</Switch>
	</React.Fragment>
)

export default routes


// WEBPACK FOOTER //
// ./src/routes/index.js